import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import 'react-step-progress-bar/styles.css';
import { ProgressBar, Step } from 'react-step-progress-bar';
import {
  saveScore
} from '../../actions/client';
import {
  NF_TEST,
} from '../../constants.js';
import TestResult from './TestResult';
import s from './NarrowFraming.css';
import cs from './common.css';

class NarrowFraming extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      qNum: 0,
      questions: [1,2,3,4,5,6,7,8],
      answers: Array.from({length: 8}),
      radios: ['',''],
    };
  }

  componentWillMount() {
    const panes = this.generateQuestions();
    this.setState(Object.assign({}, this.state, {
      panes: panes,
    }));
    this.getNextQuestion();
  }

  getNextQuestion() {
    const {
      answers,
    } = this.state;
    const questions = [].concat(this.state.questions);

    let qNum = 9;
    // if more questions get and remove one randomly
    if(questions.length > 0) {
      const index = Math.floor(Math.random() * questions.length);
      qNum = questions[index];
      questions.splice(index,1);
    }
    // update the state with current num and remaining questions
    if(qNum === 9) {
      this.props.saveScore(NF_TEST, answers);
    }
    this.setState(Object.assign({}, this.state, {
      qNum: qNum,
      questions: questions,
    }));
  }

  answerRadio(pos, val) {
    const radios = [].concat(this.state.radios);
    radios[pos] = val;
    this.setState(Object.assign({}, this.state, {
      radios: radios,
    }));
  }

  answerQuestion(val) {
    const {
      qNum,
      radios,
    } = this.state;
    const answers = [].concat(this.state.answers);
    let theVal = val;
    if(qNum === 7 || qNum === 8) {
      if(radios.includes('')) {
        return;
      }
      theVal = radios[0] + radios[1];
    }
    answers[qNum - 1] = theVal;
    const blankRads = ['',''];
    this.setState(Object.assign({}, this.state, {
      answers: answers,
      radios: blankRads,
    }), () => {
      this.getNextQuestion();
    });
  }

  render() {
    const {
      qNum,
    } = this.state;
    if(qNum === 9) {
      return (
        <TestResult />
      );
    } else {
      let scrollBase = 1140;
      if (window.matchMedia('(max-device-width: 1200px)').matches) {
        scrollBase = 940;
      }
      if (window.matchMedia('(max-device-width: 992px) and (orientation: landscape)').matches) {
        scrollBase = 710;
      }
      if (window.matchMedia('(max-device-width: 992px) and (orientation: portrait)').matches) {
        scrollBase = 384;
      }
      if (window.matchMedia('((max-device-width : 414px)').matches) {
        scrollBase = 384;
      }
      if (window.matchMedia('(max-device-width : 375px)').matches) {
        scrollBase = 345;
      }
      if (window.matchMedia('(min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
        scrollBase = 738;
      }
      if (window.matchMedia('(min-device-width : 1024px) and (max-device-width : 1366px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
        scrollBase = 994;
      }
      const ctrans = `translate(${-(((qNum - 1) * 30) + ((qNum - 1) * scrollBase))}px)`;
      return (
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className={cs.headerRow}>
              <ProgressBar
                unfilledBackground="#BDC2C6"
                filledBackground="#35ccd2"
                height='1px'
                percent={100 / 7 * (7 - this.state.questions.length)}
              >
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
              </ProgressBar>
              </div>
              <div className={cs.headerTitle}>The Big Picture Assessment</div>
            </div>
          </div>
          <div className="row">
            <div className={'col-md-12'} style={{overflow: 'hidden',paddingTop:'30px',paddingBottom:'30px'}}>
              <div className={cs.insidepane} style={{transform: ctrans}}>
                { this.state.panes }
              </div>
            </div>
          </div>
          <div className="row">
            {this.state.qNum < 7 &&
            <div className="col-md-12" style={{textAlign: 'center'}}>
              <button onClick={() => this.answerQuestion('n')} className={s.answerButton}>NO</button>
              <button onClick={() => this.answerQuestion('y')} className={s.answerButton}>YES</button>
            </div>
            }
            {this.state.qNum >= 7 &&
            <div className="col-md-12" style={{textAlign: 'center'}}>
              <button onClick={() => this.answerQuestion('n')} className={s.answerButton}>SUBMIT</button>
            </div>
            }
          </div>
        </div>
      );
    }
  }

  generateQuestions() {
    return (
      <div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
          <div className={cs.question}>
            Suppose that you have an opportunity to bet on coin flips in which you<br />
            <strong>WIN $250</strong> if the coin lands on heads and< br />
            <strong>LOSE $100</strong> if the coin lands on tails.<br /><br />
            Would you play this bet <strong>TWO</strong> times?
          </div>
          <div style={{textAlign:'center'}}>
            <div className={s.coinLeft}>+$250&nbsp;</div>
            <div className={s.coinRight}>-$100&nbsp;</div>
          </div>
        </div>
        </div>
        </div>

        <div className={cs.qpane + ' ' + cs.qpaneSize}>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
          <div className={cs.question}>
            Would you accept a bet in which you have the following
            chances of winning or losing?
          </div>
          <div className="col-md-12">
            <ReactEcharts option={ this.getQ2Chart() } style={{height: 120 }} />
          </div>
          </div>
        </div>
        </div>

        <div className={cs.qpane + ' ' + cs.qpaneSize}>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
          <div className={cs.question}>
            Suppose that you have an opportunity to bet on coin flips in which you<br />
            <strong>WIN $250</strong> if the coin lands on heads and < br />
            <strong>LOSE $100</strong> if the coin lands on tails.<br /><br />
            Would you play this bet <strong>THREE</strong> times?
          </div>
          <div style={{textAlign:'center'}}>
            <div className={s.coinLeft}>+$250&nbsp;</div>
            <div className={s.coinRight}>-$100&nbsp;</div>
          </div>
        </div>
        </div>
        </div>

        <div className={cs.qpane + ' ' + cs.qpaneSize}>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
          <div className={cs.question}>
            Would you accept a bet in which you have the following
            chances of winning or losing?
          </div>
          <div className="col-md-12">
            <ReactEcharts option={ this.getQ4Chart() } style={{ height: 160 }} />
          </div>
          </div>
        </div>
        </div>

        <div className={cs.qpane + ' ' + cs.qpaneSize}>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
          <div className={cs.question}>
            Suppose that you have an opportunity to bet on coin flips in which you<br />
            <strong>WIN $250</strong> if the coin lands on heads and< br />
            <strong>LOSE $100</strong> if the coin lands on tails.<br /><br />
            Would you play this bet <strong>TEN</strong> times?
          </div>
          <div style={{textAlign:'center'}}>
            <div className={s.coinLeft}>+$250&nbsp;</div>
            <div className={s.coinRight}>-$100&nbsp;</div>
          </div>
        </div>
        </div>
        </div>

        <div className={cs.qpane + ' ' + cs.qpaneSize}>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
          <div className={cs.question}>
            Would you accept a bet in which you have the following
            chances of winning or losing?
          </div>
          <div className="col-md-12">
            <ReactEcharts option={ this.getQ6Chart() } style={{ height: 400 }} />
          </div>
        </div>
        </div>
        </div>

        <div className={cs.qpane + ' ' + cs.qpaneSize}>
        <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-8 col-md-12">
          <div className={cs.question} style={{marginLeft:'auto', marginRight:'auto', display:'block'}}>
            Imagine that you face the following pair
            of concurrent decisions.<br />First examine both decisions, then
            indicate the options you prefer.
          </div>
          <div className={s.gambleBox}>
            <div className={s.gamble}>Decision 1:</div>
            <div style={{display:'inline-block',verticalAlign:'top', width:'320px', marginRight:'15px'}}>
              <div style={{marginBottom:'10px',textAlign:'center',fontSize:'20px',width:'320px',height:'50px'}}>
                <div style={{backgroundColor:'#84BD00', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'100%', height:'50px'}}>+$240</div>
              </div>
              <div style={{display:'inline-block',verticalAlign:'top', marginRight:'5px'}}>
                <input name="q7a" onChange={() => this.answerRadio(0,'a')} className={s.formRadio + ' ' + s.formRadioFirst} type="radio" />
              </div>
              <div style={{fontSize:'20px',display:'inline-block'}}>a sure gain of $240</div>
            </div>
            <div style={{display:'inline-block',verticalAlign:'top', width:'320px'}}>
              <div style={{marginBottom:'10px',textAlign:'center',fontSize:'20px',width:'320px',height:'50px'}}>
                <div style={{backgroundColor:'#84BD00', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'25%', height:'50px'}}>+$1000</div>
                <div style={{backgroundColor:'#f3f4f5', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'75%',height:'50px'}}>$0</div>
              </div>
              <div style={{display:'inline-block',verticalAlign:'top', marginRight:'5px'}}>
                <input name="q7a" onChange={() => this.answerRadio(0,'b')} className={s.formRadio + ' ' + s.formRadioFirst} type="radio" />
              </div>
              <div style={{width:'290px',fontSize:'20px',display:'inline-block'}}>25% chance to gain $1000<br />75% chance to gain nothing</div>
            </div>
          </div>
          <div className={s.gambleBox}>
            <div className={s.gamble}>Decision 2:</div>
            <div style={{display:'inline-block',verticalAlign:'top', width:'320px', marginRight:'15px'}}>
              <div style={{marginBottom:'10px',textAlign:'center',fontSize:'20px',width:'320px',height:'50px'}}>
                <div style={{backgroundColor:'#D22630', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'100%', height:'50px'}}>-$750</div>
              </div>
              <div style={{display:'inline-block',verticalAlign:'top', marginRight:'5px'}}>
                <input name="q7b" onChange={() => this.answerRadio(1,'c')} className={s.formRadio + ' ' + s.formRadioFirst} type="radio" />
              </div>
              <div style={{fontSize:'20px',display:'inline-block'}}>a sure loss of $750</div>
            </div>
            <div style={{display:'inline-block',verticalAlign:'top', width:'320px'}}>
              <div style={{marginBottom:'10px',textAlign:'center',fontSize:'20px',width:'320px',height:'50px'}}>
                <div style={{backgroundColor:'#D22630', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'75%', height:'50px'}}>-$1000</div>
                <div style={{backgroundColor:'#f3f4f5', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'25%',height:'50px'}}>$0</div>
              </div>
              <div style={{display:'inline-block',verticalAlign:'top', marginRight:'5px'}}>
                <input name="q71b" onChange={() => this.answerRadio(1,'d')} className={s.formRadio + ' ' + s.formRadioFirst} type="radio" />
              </div>
              <div style={{width:'290px',fontSize:'20px',display:'inline-block'}}>75% chance to lose $1000<br />25% chance to lose nothing</div>
            </div>
          </div>
          </div>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
        <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-8 col-md-12">
          <div className={cs.question} style={{marginLeft:'auto', marginRight:'auto', display:'block'}}>
            Imagine that you face the following pair
            of concurrent decisions.<br />First examine both decisions, then
            indicate the options you prefer.
          </div>
          <div className={s.gambleBox}>
            <div className={s.gamble}>Decision 1:</div>
            <div style={{display:'inline-block',verticalAlign:'top', width:'320px', marginRight:'15px'}}>
              <div style={{marginBottom:'10px',textAlign:'center',fontSize:'20px',width:'320px',height:'50px'}}>
                <div style={{backgroundColor:'#84BD00', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'100%', height:'50px'}}>+$1200</div>
              </div>
              <div style={{display:'inline-block',verticalAlign:'top', marginRight:'5px'}}>
                <input name="q8a" onChange={() => this.answerRadio(0,'a')} className={s.formRadio + ' ' + s.formRadioFirst} type="radio" />
              </div>
              <div style={{fontSize:'20px',display:'inline-block'}}>a sure gain of $1200</div>
            </div>
            <div style={{display:'inline-block',verticalAlign:'top', width:'320px'}}>
              <div style={{marginBottom:'10px',textAlign:'center',fontSize:'20px',width:'320px',height:'50px'}}>
                <div style={{backgroundColor:'#84BD00', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'25%', height:'50px'}}>+$5000</div>
                <div style={{backgroundColor:'#f3f4f5', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'75%',height:'50px'}}>$0</div>
              </div>
              <div style={{display:'inline-block',verticalAlign:'top', marginRight:'5px'}}>
                <input name="q8a" onChange={() => this.answerRadio(0,'b')} className={s.formRadio + ' ' + s.formRadioFirst} type="radio" />
              </div>
              <div style={{width:'290px',fontSize:'20px',display:'inline-block'}}>25% chance to gain $5000<br />75% chance to gain nothing</div>
            </div>
          </div>
          <div className={s.gambleBox}>
            <div className={s.gamble}>Decision 2:</div>
            <div style={{display:'inline-block',verticalAlign:'top', width:'320px', marginRight:'15px'}}>
              <div style={{marginBottom:'10px',textAlign:'center',fontSize:'20px',width:'320px',height:'50px'}}>
                <div style={{backgroundColor:'#D22630', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'100%', height:'50px'}}>-$3750</div>
              </div>
              <div style={{display:'inline-block',verticalAlign:'top', marginRight:'5px'}}>
                <input name="q8b" onChange={() => this.answerRadio(1,'c')} className={s.formRadio + ' ' + s.formRadioFirst} type="radio" />
              </div>
              <div style={{fontSize:'20px',display:'inline-block'}}>a sure loss of $3750</div>
            </div>
            <div style={{display:'inline-block',verticalAlign:'top', width:'320px'}}>
              <div style={{marginBottom:'10px',textAlign:'center',fontSize:'20px',width:'320px',height:'50px'}}>
                <div style={{backgroundColor:'#D22630', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'75%', height:'50px'}}>-$5000</div>
                <div style={{backgroundColor:'#f3f4f5', paddingTop:'12px', display:'inline-block',verticalAlign:'top', width:'25%',height:'50px'}}>$0</div>
              </div>
              <div style={{display:'inline-block',verticalAlign:'top', marginRight:'5px'}}>
                <input name="q8b" onChange={() => this.answerRadio(1,'d')} className={s.formRadio + ' ' + s.formRadioFirst} type="radio" />
              </div>
              <div style={{width:'290px',fontSize:'20px',display:'inline-block'}}>75% chance to lose $5000<br />25% chance to lose nothing</div>
            </div>
          </div>
        </div>
        </div>
        </div>
      </div>
    );
  }

  getQ2Chart() {
    const labelRight = {
      show: true,
      fontSize:14,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'right',
    };
    const labelLeft = {
      show: true,
      fontSize:14,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'left',
    };
    const grayBar = 'rgba(0,0,0,0.025)';
    return {
      color: ['#84BD00','#D22630'],
      grid: {
          top: '0',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
      },
      xAxis : [
        {
          type : 'value',
          min: -1000,
          max: 2500,
          splitLine: {show: false},
          axisTick: {show: false},
          axisLabel: {
            show: false,
            fontSize: 14,
            formatter: function (val) {
              if(val < 0) {
                return '-$' + (val * -1).toLocaleString();
              } else if(val > 0) {
                return'$' + val.toLocaleString();
              } else {
                return val;
              }
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
                color: '#5b6770',
            },
          },
        },
      ],
      yAxis : [
        {
          type : 'category',
          data : ['25% chance', '50% chance', '25% chance'],
          axisLabel: {
            show: true,
            fontSize: 14,
          },
          axisTick: {show: false},
          splitLine: {show: false},
          axisLine: {
            lineStyle: {
                color: '#5b6770',
            },
          },
        },
      ],
      series : [
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          itemStyle: {
              normal: {color: grayBar},
          },
          data: [2500, 2500, 2500],
          animation: false,
        },
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          itemStyle: {
              normal: {color: grayBar},
          },
          data: [-1000, -1000, -1000],
          animation: false,
          markLine : {
            symbol:'none',
            lineStyle: {
              color:'#FFFFFF',
              type: 'solid',
              width: 3,
            },
            data : [
                {xAxis: 0, name : ''},
            ],
          },
        },
        {
          type:'bar',
          barWidth: '90%',
          silent: true,
          data:[0, {value: 250, label: labelLeft}, {value: 500, label: labelLeft}],
          animation: false,
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  const val = params.data.value;
                  return '$' + val.toLocaleString();
                },
            },
          },
        },
        {
            type:'bar',
            barWidth: '90%',
            silent: true,
            data:[{value: -200, label: labelRight}, 0, 0],
            animation: false,
            label: {
              normal: {
                  show: false,
                  formatter: function (params) {
                    const val = params.data.value;
                    return '- $' + (val * -1).toLocaleString();
                  },
              },
            },
        },
      ],
    };
  }

  getQ4Chart() {
    const labelRight = {
      show: true,
      fontSize:14,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'right',
    };
    const labelLeft = {
      show: true,
      fontSize:14,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'left',
    };
    const grayBar = 'rgba(0,0,0,0.025)';
    return {
      color: ['#84BD00','#D22630'],
      grid: {
          top: '0',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
      },
      xAxis : [
        {
          type : 'value',
          min: -1000,
          max: 2500,
          splitLine: {show: false},
          axisTick: {show: false},
          axisLabel: {
            show: false,
            fontSize: 14,
            formatter: function (val) {
              if(val < 0) {
                return '-$' + (val * -1).toLocaleString();
              } else if(val > 0) {
                return'$' + val.toLocaleString();
              } else {
                return val;
              }
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
                color: '#5b6770',
            },
          },
        },
      ],
      yAxis : [
        {
          type : 'category',
          data : ['12.5% chance', '37.5% chance', '37.5% chance', '12.5% chance'],
          axisLabel: {
            show: true,
            fontSize: 14,
          },
          axisTick: {show: false},
          splitLine: {show: false},
          axisLine: {
            lineStyle: {
                color: '#5b6770',
            },
          },
        },
      ],
      series : [
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          itemStyle: {
              normal: {color: grayBar},
          },
          data: [2500, 2500, 2500, 2500],
          animation: false,
        },
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          itemStyle: {
              normal: {color: grayBar},
          },
          data: [-1000, -1000, -1000, -1000],
          animation: false,
          markLine : {
            symbol:'none',
            lineStyle: {
              color:'#FFFFFF',
              type: 'solid',
              width: 3,
            },
            data : [
                {xAxis: 0, name : ''},
            ],
          },
        },
        {
          type:'bar',
          barWidth: '90%',
          silent: true,
          data:[0, {value: 50, label: labelLeft}, {value: 400, label: labelLeft}, {value: 750, label: labelLeft}],
          animation: false,
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  const val = params.data.value;
                  return '$' + val.toLocaleString();
                },
            },
          },
        },
        {
          type:'bar',
          barWidth: '90%',
          silent: true,
          data:[{value: -300, label: labelRight}, 0, 0, 0],
          animation: false,
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  const val = params.data.value;
                  return '- $' + (val * -1).toLocaleString();
                },
            },
          },
        },
      ],
    };
  }

  getQ6Chart() {
    const labelRight = {
      show: true,
      fontSize:14,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'right',
    };
    const labelLeft = {
      show: true,
      fontSize:14,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'left',
    };
    const grayBar = 'rgba(0,0,0,0.025)';
    return {
      color: ['#84BD00','#D22630'],
      grid: {
          top: '0',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
      },
      xAxis : [
        {
          type : 'value',
          min: -1250,
          max: 2500,
          splitLine: {show: false},
          axisTick: {show: false},
          axisLabel: {
            show: false,
            fontSize: 14,
            formatter: function (val) {
              if(val < 0) {
                return '-$' + (val * -1).toLocaleString();
              } else if(val > 0) {
                return '$' + val.toLocaleString();
              } else {
                return val;
              }
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
                color: '#5b6770',
            },
          },
        },
      ],
      yAxis : [
        {
          type : 'category',
          data : ['0.1% chance', '1.0% chance', '4.4% chance', '11.7% chance', '20.5% chance', '24.6% chance',
          '20.5% chance', '11.7% chance', '4.4% chance', '1.0% chance', '0.1% chance'],
          axisLabel: {
            show: true,
            fontSize: 14,
          },
          axisTick: {show: false},
          splitLine: {show: false},
          axisLine: {
            lineStyle: {
                color: '#5b6770',
            },
          },
        },
      ],
      series : [
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          itemStyle: {
              normal: {color: grayBar},
          },
          data: [2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500],
          animation: false,
        },
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          itemStyle: {
              normal: {color: grayBar},
          },
          data: [-1250, -1250, -1250, -1250, -1250, -1250, -1250, -1250, -1250, -1250, -1250],
          animation: false,
          markLine : {
            symbol:'none',
            lineStyle: {
              color:'#FFFFFF',
              type: 'solid',
              width: 3,
            },
            data : [
                {xAxis: 0, name : ''},
            ],
          },
        },
        {
            type:'bar',
            barWidth: '90%',
            silent: true,
            data:[0, 0, 0,
              {value: 50, label: labelLeft},
              {value: 400, label: labelLeft},
              {value: 750, label: labelLeft},
              {value: 1100, label: labelLeft},
              {value: 1450, label: labelLeft},
              {value: 1800, label: labelLeft},
              {value: 2150, label: labelLeft},
              {value: 2500, label: labelLeft},
            ],
            animation: false,
            label: {
              normal: {
                  show: false,
                  formatter: function (params) {
                    const val = params.data.value;
                    return '$' + val.toLocaleString();
                  },
              },
            },
        },
        {
          type:'bar',
          barWidth: '90%',
          silent: true,
          data:[
            {value: -1000, label: labelRight},
            {value: -650, label: labelRight},
            {value: -300, label: labelRight},
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
          animation: false,
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  const val = params.data.value;
                  return '- $' + (val * -1).toLocaleString();
                },
            },
          },
        },
      ],
    };
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveScore,
})(NarrowFraming);



// WEBPACK FOOTER //
// ./src/components/ClientMode/NarrowFraming.js